// extracted by mini-css-extract-plugin
export default {"scm-header-layout-content":"E0ZoupWl_I9vVs50Th6E","content-layout":"huJ6_1RzRK3zSyNN7hUg"};